import apiClient from './api';

export interface Context {
  id: number;
  name: string;
  type: string;
  status: string;
  creation_date: string;
  text?: string | null;
  source?: string;
}

interface ContextCreatePayload {
    name: string;
    type: string;
    text?: string;
    source?: string;
}

interface ContextUpdatePayload {
  name?: string;
}

export const createContext = async (projectId: string, payload: ContextCreatePayload): Promise<Context> => {
  const { data } = await apiClient.post(`/proyectos/${projectId}/contexts/`, payload);
  return data;
};

export const updateContext = async (projectId: string, contextId: number, payload: ContextUpdatePayload): Promise<Context> => {
  const { data } = await apiClient.put(`/proyectos/${projectId}/contexts/${contextId}`, payload);
  return data;
};

export const deleteContext = async (projectId: string, contextId: number): Promise<void> => {
  await apiClient.delete(`/proyectos/${projectId}/contexts/${contextId}`);
}; 